import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c3e091f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ef-infos" }
const _hoisted_2 = { class: "ef-line" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"ef-line -full\" data-v-2c3e091f><div class=\"ef-infos__contact\" data-v-2c3e091f><i class=\"fa-solid fa-address-card\" data-v-2c3e091f></i><div class=\"ef-infos__infos\" data-v-2c3e091f><div class=\"ef-infos__name\" data-v-2c3e091f>Jean la Frite</div><div class=\"ef-infos__role\" data-v-2c3e091f>Support</div><div class=\"ef-infos__email\" data-v-2c3e091f>lafrite@silae.fr</div></div></div><div class=\"ef-infos__contact\" data-v-2c3e091f><i class=\"fa-solid fa-address-card\" data-v-2c3e091f></i><div class=\"ef-infos__infos\" data-v-2c3e091f><div class=\"ef-infos__name\" data-v-2c3e091f>Anne la Salade</div><div class=\"ef-infos__role\" data-v-2c3e091f>Responsable IT</div><div class=\"ef-infos__email\" data-v-2c3e091f>lasalade@silae.fr</div></div></div><div class=\"ef-infos__contact\" data-v-2c3e091f><i class=\"fa-solid fa-address-card\" data-v-2c3e091f></i><div class=\"ef-infos__infos\" data-v-2c3e091f><div class=\"ef-infos__name\" data-v-2c3e091f>Max la menace</div><div class=\"ef-infos__role\" data-v-2c3e091f>Hapyness manager</div><div class=\"ef-infos__email\" data-v-2c3e091f>lamenace@silae.fr</div></div></div></div><div class=\"ef-line\" data-v-2c3e091f></div>", 2)

import Header from '@/components/Header.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header, {
        icone: "fa-solid fa-question",
        title: "Informations"
      })
    ]),
    _hoisted_3
  ]))
}
}

})